import { config } from '../helpers'

export const homeMessageService = {
    getHomeMessages
}

async function getHomeMessages() {
    try {
        const response = await fetch(`${config.apiUrl}/home_messages`, { method: 'GET' });

        return await response.json();
    } catch (error) {
        console.error('Could not get home messages:', error);
        return [];
    }
}